import { LoadingButton } from '@mui/lab';
import {
  Box,
  Button,
  TextField,
  Typography,
  IconButton,
  Autocomplete,
  Card,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { experimentalStyled as styled } from '@mui/material/styles';
import { nanoid } from 'nanoid';
import { updateUser, getUserDetails } from '../../service/user.service';
import { fetchEduBoards } from '../../service/cms.service';
import BackArrowIcon from '../../svg/BackArrowIcon';
import { getCke } from '../../helper/cookieHelper';
import { UPDATE_ORG, UPDATE_USER } from '../../redux/constants';
import { createOrganization } from '../../service/org.service';
import BackgroundImage from '../../svg/FainlearnBackSvg.svg';
import Page from '../Page';
import { USER_AVATAR } from '../../utils/constants';

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const useStyles = makeStyles({
  wrapper: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  button: {
    width: '100%',
    fontSize: '16px',
    padding: '10px 0',
    borderRadius: '100px'
  },
  form: {
    display: 'flex',
    flexDirection: 'column'
  }
});

export default function SchoolForm({ handleBack }) {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [fullName, setFullName] = useState(currentUser?.fullName ?? '');
  // const [cityData, setCityData] = useState([]);
  const [schoolName, setSchoolName] = useState('');
  const [gender, setGender] = useState('male');
  // const [city, setCity] = useState('');
  // const [email, setEmail] = useState('');
  // const [state, setState] = useState('');
  const [displayAdditionalInfo, setIsAdditionalInfo] = useState(false);
  const [isBtnLoading, setBtnLoading] = useState(false);
  // const [schoolAlias, setSchoolAlias] = useState('');
  const [eduBoardData, setEduBoardData] = useState([]);
  // const [stateData, setStateData] = useState([]);
  const [eduBoard, setEduBoard] = useState('');
  // const [address, setAddress] = useState('');
  // const [website, setWebsite] = useState('');
  // const [zipcode, setZipCode] = useState('');
  const [isOtherBoardSelected, setIsOtherBoardSelected] = useState(false);
  const [customBoardName, setCustomBoardName] = useState('');

  const [schoolNameError, setSchoolNameErr] = useState('');

  useEffect(() => {
    async function getStateAndCities() {
      const res = await fetchEduBoards();
      // const stateAndEduRes = await Promise.all([
      //   fetchStatesForIndia(),
      //   fetchEduBoards(),
      //   fetchCitiesForIndia()
      // ]);
      // if (stateAndEduRes[0]) {
      //   setStateData(FilterArrayByKey(stateAndEduRes[0], 'name'));
      // } else {
      //   setStateData([]);
      // }

      if (res) {
        const newData = res;
        newData.push({
          id: nanoid(),
          name: 'Other'
        });
        setEduBoardData(newData);
      } else {
        setEduBoardData([]);
      }

      // if (stateAndEduRes[2]) {
      //   setCityData(FilterArrayByKey(stateAndEduRes[2], 'name'));
      // } else {
      //   setCityData([]);
      // }
    }
    getStateAndCities();
  }, []);

  const handleNext = async () => {
    let isAllFieldValid = true;
    await yup
      .string()
      .required()
      .isValid(schoolName)
      .then((isValid) => {
        if (!isValid) {
          isAllFieldValid = false;
          setSchoolNameErr(true);
        }
      });

    if (isAllFieldValid) {
      // setBtnLoading(true);
      // const userObj = {
      //   fullName: fullName.trim(),
      //   profile: 'admin',
      //   isOnboarding: false
      // };
      // const userId = getCke('userId');
      // const res = await updateUser(userId, userObj);
      // if (res) {
      // const getUserRes = await getUserDetails(userId);
      // if (getUserRes) {
      //   dispatch({ type: UPDATE_USER, payload: getUserRes });
      // }
      // setIsAdditionalInfo(true);
      handleProceed();
      // }
      // setBtnLoading(false);
    }
  };

  // const handleSkip = () => {
  //   navigate('/', { replace: true });
  // };

  const handleProceed = async () => {
    setBtnLoading(true);
    const userId = getCke('userId');
    const orgObj = {
      name: schoolName.trim(),
      orgType: 'school',
      country: 'India',
      phoneNumber: `${currentUser.mobileNumber}`,
      isOnboarding: false,
      role: 'admin'
    };
    // if (schoolAlias.trim() !== '') orgObj.alias = schoolAlias;
    // if (city) orgObj.city = city;
    // if (address) orgObj.address = address;
    // if (eduBoard) orgObj.eduBoard = eduBoard;
    if (isOtherBoardSelected) {
      orgObj.eduBoard = `Other, ${customBoardName.trim()}`;
    } else {
      orgObj.eduBoard = eduBoard;
    }
    // if (website) orgObj.website = website;
    // if (state) orgObj.state = state;
    // if (zipcode) orgObj.zipcode = zipcode;

    // Update user
    const userObj = {
      fullName: fullName.trim(),
      gender,
      profile: 'admin',
      isOnboarding: false,
      profileImage: USER_AVATAR.filter((avatar) => avatar.includes(`_${gender}`))[
        Math.floor(Math.random() * 3)
      ]
    };
    // if (email.trim() !== '') userObj.email = email;
    const orgRes = await createOrganization(orgObj);
    if (orgRes) {
      const res = await updateUser(userId, userObj);
      if (res && Object.keys(res).length > 0) {
        const getUserRes = await getUserDetails(userId);
        dispatch({ type: UPDATE_USER, payload: getUserRes.user });
        dispatch({ type: UPDATE_ORG, payload: getUserRes.orgList });
        navigate('/', { replace: true });
      } else {
        await updateUser(userId, {
          fullName: fullName.trim(),
          isOnboarding: true
        });
      }
    }
    setBtnLoading(false);
  };

  return (
    <RootStyle
      title="Fainlearn | Select User"
      isDivRender={false}
      style={{
        backgroundImage: `url(${BackgroundImage})`,
        backgroundSize: 'cover'
      }}
    >
      <Box className={classes.wrapper}>
        <Card
          style={{
            position: 'relative',
            padding: '0 15px',
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '480px',
            width: '100%'
          }}
        >
          <Box component="img" src="/static/logo-new.svg" sx={{ height: '100px' }} />
          <Box sx={{ padding: '20px' }}>
            <Box className={classes.form}>
              <Typography variant="h4" sx={{ marginBottom: '5px' }}>
                {displayAdditionalInfo && (
                  <IconButton onClick={() => setIsAdditionalInfo(false)}>
                    <BackArrowIcon />
                  </IconButton>
                )}
                School Form
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: '30px' }}>
                Complete the form below to get started.
              </Typography>
              {/* {displayAdditionalInfo ? (
                <>
                  <TextField
                    style={{ marginBottom: '20px' }}
                    label="School Short Name"
                    placeholder="Eg. New Era"
                    value={schoolAlias}
                    onChange={(e) => setSchoolAlias(e.target.value)}
                  />
                  <TextField
                    fullWidth
                    style={{ marginBottom: '20px' }}
                    value={website}
                    placeholder="Eg. https://google.com"
                    label="Website"
                    onChange={(e) => setWebsite(e.target.value)}
                  />
                  <TextField
                    style={{ marginBottom: '20px' }}
                    label="Email"
                    placeholder="Eg. example@gmail.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <TextField
                    style={{ marginBottom: '20px' }}
                    label="Address"
                    value={address}
                    placeholder="Eg. New era school, opp. tesla ground"
                    onChange={(e) => setAddress(e.target.value)}
                  />
                  <Autocomplete
                    id="city-select"
                    options={cityData}
                    style={{ marginBottom: '20px' }}
                    freeSolo
                    getOptionLabel={(option) => option.name}
                    fullWidth
                    onChange={(e, v) => {
                      setCity(v?.name ?? '');
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select City"
                        variant="outlined"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'new-password'
                        }}
                      />
                    )}
                  />
                  <Autocomplete
                    id="city-select"
                    options={stateData}
                    style={{ marginBottom: '20px' }}
                    freeSolo
                    getOptionLabel={(option) => option.name}
                    fullWidth
                    onChange={(e, v) => {
                      setState(v?.name ?? '');
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select State"
                        variant="outlined"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'new-password'
                        }}
                      />
                    )}
                  />
                  <TextField
                    fullWidth
                    type="number"
                    style={{ marginBottom: '20px' }}
                    value={zipcode}
                    placeholder="Eg. 123456"
                    label="Zipcode"
                    onChange={(e) => setZipCode(e.target.value.toString().slice(0, 6))}
                  />
                </>
              ) : (
                <> */}
              <TextField
                style={{ marginBottom: '20px' }}
                label="School Name"
                placeholder="Eg. New Era High School"
                value={schoolName}
                onChange={(e) => setSchoolName(e.target.value)}
                error={schoolNameError && !schoolName}
                helperText={schoolNameError && !schoolName ? 'Full Name is required' : ''}
              />
              <TextField
                style={{ marginBottom: '20px' }}
                label="Your Name"
                placeholder="Eg. John Doe"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
              <Box style={{ marginBottom: '20px' }}>
                <FormLabel>Gender</FormLabel>
                <RadioGroup row value={gender} onChange={(e) => setGender(e.target.value)}>
                  <FormControlLabel value="male" control={<Radio />} label="Male" />
                  <FormControlLabel value="female" control={<Radio />} label="Female" />
                </RadioGroup>
              </Box>
              <Autocomplete
                id="city-select"
                options={eduBoardData}
                style={{ marginBottom: '20px' }}
                freeSolo
                getOptionLabel={(option) => option.name}
                fullWidth
                onChange={(e, v) => {
                  setEduBoard(v?.name ?? '');
                  if (v?.name.toLowerCase() === 'other') setIsOtherBoardSelected(true);
                  else setIsOtherBoardSelected(false);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select affiliated board"
                    variant="outlined"
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'new-password',
                      form: {
                        autocomplete: 'off'
                      }
                    }}
                  />
                )}
              />

              {isOtherBoardSelected && (
                <TextField
                  style={{ marginBottom: '20px' }}
                  label="Name of board"
                  placeholder="Eg. GSEB"
                  value={customBoardName}
                  onChange={(e) => setCustomBoardName(e.target.value)}
                />
              )}
              {/* </>
              )} */}
              <Box sx={{ display: 'flex', marginTop: '30px' }}>
                {/* {displayAdditionalInfo ? (
                  <>
                    <Button
                      variant="outlined"
                      className={classes.button}
                      sx={{ marginRight: '30px' }}
                      onClick={handleProceed}
                    >
                      Skip
                    </Button>
                    <LoadingButton
                      loading={isBtnLoading}
                      variant="contained"
                      className={classes.button}
                      onClick={handleProceed}
                    >
                      Proceed
                    </LoadingButton>
                  </>
                ) : (
                  <> */}
                <Button
                  variant="outlined"
                  className={classes.button}
                  sx={{ marginRight: '30px' }}
                  onClick={handleBack}
                  disabled={isBtnLoading}
                >
                  Back
                </Button>
                <LoadingButton
                  loading={isBtnLoading}
                  variant="contained"
                  className={classes.button}
                  onClick={handleNext}
                >
                  Proceed
                </LoadingButton>
                {/* </>
                )} */}
              </Box>
            </Box>
          </Box>
        </Card>
      </Box>
    </RootStyle>
  );
}

SchoolForm.propTypes = {
  handleBack: PropTypes.func
};
